import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Download, Printer, Copy } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const DocViewer = ({ doc, onClose }) => {
  const download = () => {
    const blob = new Blob([doc.content], { type: "text/markdown" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `${doc.title.replace(/\s+/g, "-")}.md`;
    a.click();
  };
  return (
    <Dialog open={!!doc} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl max-h-[88vh] overflow-y-auto" data-testid="doc-viewer">
        <DialogHeader>
          <DialogTitle>{doc?.title}</DialogTitle>
        </DialogHeader>
        <div className="flex gap-2 flex-wrap">
          <Button size="sm" variant="outline" onClick={download} data-testid="doc-download-btn"><Download className="h-4 w-4 mr-1" />Download</Button>
          <Button size="sm" variant="outline" onClick={() => window.print()} data-testid="doc-print-btn"><Printer className="h-4 w-4 mr-1" />Print / PDF</Button>
          <Button size="sm" variant="outline" onClick={() => { navigator.clipboard.writeText(doc.content); toast.success("Copied"); }} data-testid="doc-copy-btn"><Copy className="h-4 w-4 mr-1" />Copy</Button>
        </div>
        <div className="prose-aq print-area border-t border-border pt-4" data-testid="doc-viewer-content">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{doc?.content || ""}</ReactMarkdown>
        </div>
      </DialogContent>
    </Dialog>
  );
};
